export default "__VITE_ASSET__Czi0Bstv__"